<div class="loading-overlay" *ngIf="loading$ | async">
  <div class="spinner"></div>
</div>
